import { escapeAttr } from "@emkit/builder-core";
export const IMAGE_DEFAULTS = {
    src: "https://placehold.co/1200x675",
    alt: "",
    loading: "lazy",
    fit: "cover",
};
export const imageWidget = {
    type: "image",
    defaultProps: IMAGE_DEFAULTS,
    renderHtml(props, ctx) {
        const url = ctx.resolveAssetUrl ? ctx.resolveAssetUrl(props.src) : props.src;
        const attrs = [
            `src="${escapeAttr(url)}"`,
            `alt="${escapeAttr(props.alt)}"`,
            `loading="${props.loading ?? "lazy"}"`,
            `decoding="async"`,
            `class="emk-image"`,
        ];
        if (props.width)
            attrs.push(`width="${props.width}"`);
        if (props.height)
            attrs.push(`height="${props.height}"`);
        const styleParts = ["display:block", "max-width:100%", "height:auto"];
        if (props.fit)
            styleParts.push(`object-fit:${props.fit}`);
        if (props.radius !== undefined)
            styleParts.push(`border-radius:${props.radius}px`);
        attrs.push(`style="${styleParts.join(";")}"`);
        return `<img ${attrs.join(" ")}>`;
    },
};
//# sourceMappingURL=image.js.map